import { FC, useState, useEffect, ChangeEvent } from 'react';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { groupsActions } from 'store/group/groupSlice';
import { getFilter, getGroupItems } from 'store/group/groupSelectors';
// Components
import { Input } from 'components/Controls';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {}

let timeout:any = null;

const GroupsFilter:FC<Props> = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  
  const groups = useAppSelector(getGroupItems);
  const filter = useAppSelector(getFilter);

  const [ stateFilter, setStateFilter ] = useState<any>(filter);

  useEffect(() => {
    return () => {
      if ( timeout ) clearTimeout(timeout);
      dispatch(groupsActions.setInitialField('filter'));
    }
    // eslint-disable-next-line
  }, []);

  const handleChange = (event:ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setStateFilter((prevState:any) => ({ ...prevState, [name]: value }));
    if ( timeout ) clearTimeout(timeout);
    timeout = setTimeout(() => {
      dispatch(groupsActions.setFilter({ [name]: value} ));
    }, 1000);
  }

  if ( !groups || groups.length === 0 ) return null;
  return (
    <Input
      className="mb-0"
      id="search" name="search" value={stateFilter.search} placeholder={t('labels.search')}
      onChange={handleChange}
    />
  )
}

export default GroupsFilter;
